module.exports = __webpack_public_path__ + "static/media/reportar.3ef5ed45.svg";